import { useEffect, useState } from 'react';
import { api, type User } from './lib/api';
import { Login } from './pages/Login';
import { MeetingList } from './pages/MeetingList';
import { MeetingView } from './pages/MeetingView';

function useHashRoute(): string {
  const [hash, setHash] = useState(window.location.hash);
  useEffect(() => {
    const onChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);
  return hash;
}

export function navigate(path: string): void {
  window.location.hash = path;
}

export function App() {
  const [user, setUser] = useState<User | null | undefined>(undefined);
  const hash = useHashRoute();

  useEffect(() => {
    api.me().then(setUser, () => setUser(null));
    const onUnauthorized = () => setUser(null);
    window.addEventListener('mr:unauthorized', onUnauthorized);
    return () => window.removeEventListener('mr:unauthorized', onUnauthorized);
  }, []);

  if (user === undefined) return <div className="center muted">Laddar…</div>;
  if (!user) return <Login onLogin={setUser} />;

  const meetingMatch = hash.match(/^#\/m\/([0-9a-f-]{36})/);
  return (
    <div className="app">
      <header className="topbar">
        <a className="brand" href="#/">
          <img className="brand-logo" src="/svava-icon.png" alt="" />
          Svava Meet
        </a>
        <div className="topbar-right">
          <span className="muted small hide-mobile">{user.email}</span>
          <button
            className="btn ghost small"
            onClick={async () => {
              await api.logout().catch(() => undefined);
              setUser(null);
            }}
          >
            Logga ut
          </button>
        </div>
      </header>
      <main>{meetingMatch ? <MeetingView key={meetingMatch[1]} id={meetingMatch[1]} /> : <MeetingList />}</main>
    </div>
  );
}
